import type { SvgIconProps } from "@mui/material";
import { styled } from "@mui/material";
import { forwardRef } from "react";

import minAndMaxBoundedSvg from "./candidate-constraint-icon.min-and-max-bounded.svg?react";
import minBoundedSvg from "./candidate-constraint-icon.min-bounded.svg?react";
import { makeSvgIcon } from "./svg-icon";

const CandidateConstraintIconMinBounded = makeSvgIcon(
  minBoundedSvg,
  (theme) => theme.palette.grey[300]
);

const CandidateConstraintIconMaxBounded = styled(
  CandidateConstraintIconMinBounded
)({
  transform: "scale(-1, 1)",
});

const CandidateConstraintIconMinAndMaxBounded = makeSvgIcon(
  minAndMaxBoundedSvg,
  (theme) => theme.palette.grey[300]
);

/**
 * Should be bounded on either one end or both ends, doesn't make sense
 * to set both `minBounded` and `maxBounded` to false.
 */
export const CandidateConstraintIcon = forwardRef(function (
  {
    maxBounded = true,
    minBounded = true,
    ...props
  }: SvgIconProps & { maxBounded?: boolean; minBounded?: boolean },
  ref: React.Ref<SVGSVGElement>
) {
  return minBounded && maxBounded ? (
    <CandidateConstraintIconMinAndMaxBounded {...props} ref={ref} />
  ) : minBounded ? (
    <CandidateConstraintIconMinBounded {...props} ref={ref} />
  ) : (
    <CandidateConstraintIconMaxBounded {...props} ref={ref} />
  );
});

export default CandidateConstraintIcon;
